<template>
  <button
    ref="cncIconButton"
    type="button"
    :class="`cnc-icon-button ${sizeButton[size]} ${typeStyle[type].className} ${shapeButton[shape]}`"
    :disabled="disabled"
    :data-qa="`${qa ? `icon-btn-${qa}` : 'icon-btn' }`"
    :style="type === 'custom' ? { backgroundColor: backgroundColor } : {}"
    @click.stop="$emit('clickStop')"
    @click="$emit('click')"
  >
    <CncIcon
      v-if="iconName && iconName.name"
      :name="iconName.name"
      :color="typeStyle[type].color || iconName.color"
      :color2="typeStyle[type].color2 || iconName.color2"
      :isTwoTone="iconName.isTwoTone"
      :width="iconWidth"
    />
  </button>
</template>

<script>
export default {
  props: {
    iconName: { type: Object, default: () => ({}) },
    size: { type: String, default: 'large' },
    type: { type: String, default: 'filled' },
    shape: { type: String, default: 'round' },
    disabled: { type: Boolean },
    qa: { type: String },
    backgroundColor: { type: String }
  },
  data () {
    return {
      typeStyle: {
        'filled': { className: 'icon-button-filled', color: '#fff', color2: this.$store.state.color['primary-200'] },
        'tonal': { className: 'icon-button-tonal', color: this.$store.state.color['primary-500'], color2: this.$store.state.color['primary-200'] },
        'tonal-outlined': { className: 'icon-button-tonal-outlined', color: this.$store.state.color['primary-500'], color2: this.$store.state.color['primary-200'] },
        'tonal-alt': { className: 'icon-button-tonal-alt', color: this.$store.state.color['secondary-500'], color2: this.$store.state.color['secondary-200'] },
        'tonal-alt-outlined': { className: 'icon-button-tonal-alt-outlined', color: this.$store.state.color['secondary-500'], color2: this.$store.state.color['secondary-200'] },
        'neutral': { className: 'icon-button-neutral', color: this.$store.state.color['coolGrey-600'], color2: this.$store.state.color['coolGrey-200'] },
        'neutral-outlined': { className: 'icon-button-neutral-outlined', color: this.$store.state.color['coolGrey-600'], color2: this.$store.state.color['coolGrey-200'] },
        'ghost': { className: 'icon-button-ghost', color: this.$store.state.color['coolGrey-700'], color2: this.$store.state.color['coolGrey-200'] },
        'filled-on-color': { className: 'icon-button-filled-on-color', color: this.$store.state.color['primary-500'], color2: this.$store.state.color['primary-200'] },
        'outline-on-color': { className: 'icon-button-outline-on-color', color: '#fff', color2: this.$store.state.color['primary-200'] },
        'custom': { className: 'icon-button-custom' }
      },
      sizeButton: {
        'large': 'icon-button-large',
        medium: 'icon-button-medium',
        small: 'icon-button-small'
      },
      shapeButton: {
        'round': '',
        'square': 'icon-button-square'
      }
    }
  },
  computed: {
    iconWidth () {
      return this.size === 'large' ? 24 : this.size === 'medium' ? 24 : this.size === 'small' ? 20 : 20
    }
  }
}
</script>

<style lang="scss">
.cnc-icon-button{
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;

  svg {
    width: 24px !important;
    height: 24px !important;
  }

  &.icon-button-large {
    height: $space-3xl;
    width: $space-3xl;

    &.icon-button-square{
      border-radius: 20px;
    }
  }

  &.icon-button-medium {
    height: $space-2xl;
    width: $space-2xl;

    &.icon-button-square{
      border-radius: 16px;
    }
  }

  &.icon-button-small {
    height: $space-xl;
    width: $space-xl;

    &.icon-button-square{
      border-radius: 12px;
    }

    .lego-icon i{
      font-size: $space-md;
    }

    svg {
      width: 20px !important;
      height: 20px !important;
    }
  }

  &.icon-button-filled {
      color: $color-white;
      background-color: $color-primary-500;
      border-color: $color-primary-500;

      &:hover {
        color: $color-white;
        background-color: $color-primary-600;
        border-color: $color-primary-600;
      }

      &:focus-visible {
        color: $color-white;
        background-color: $color-primary-500;
        border-color: $color-primary-500;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
      }

      &:active {
        color: $color-white;
        background-color: $color-primary-700;
        border-color: $color-primary-700;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-tonal {
      color: $color-primary-500;
      background-color: $color-primary-50;
      border-color: $color-primary-50;

      &:hover {
        color: $color-primary-500;
        background-color: $color-primary-100;
        border-color: $color-primary-100;
      }

      &:focus-visible {
        color: $color-primary-500;
        background-color: $color-primary-50;
        border-color: $color-primary-50;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
      }

      &:active {
        color: $color-primary-500;
        background-color: $color-primary-200;
        border-color: $color-primary-200;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-tonal-outlined {
      color: $color-primary-500;
      background-color: $color-primary-50;
      border: 1px solid $color-primary-200;

      &:hover {
        color: $color-primary-500;
        background-color: $color-primary-100;
        border-color: $color-primary-100;
        border: 1px solid $color-primary-200;
      }

      &:focus-visible {
        color: $color-primary-500;
        background-color: $color-primary-50;
        border-color: $color-primary-50;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
        border: 1px solid $color-primary-200;
      }

      &:active {
        color: $color-primary-500;
        background-color: $color-primary-200;
        border-color: $color-primary-200;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-tonal-alt {
      color: $color-secondary-500;
      background-color: $color-secondary-50;
      border-color: $color-secondary-50;

      &:hover {
        color: $color-secondary-500;
        background-color: $color-secondary-100;
        border-color: $color-secondary-100;
      }

      &:focus-visible {
        color: $color-secondary-500;
        background-color: $color-secondary-50;
        border-color: $color-secondary-50;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
      }

      &:active {
        color: $color-secondary-500;
        background-color: $color-secondary-200;
        border-color: $color-secondary-200;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-tonal-alt-outlined {
      color: $color-secondary-500;
      background-color: $color-secondary-50;
      border: 1px solid $color-secondary-200;

      &:hover {
        color: $color-secondary-500;
        background-color: $color-secondary-100;
        border-color: $color-secondary-100;
        border: 1px solid $color-secondary-200;
      }

      &:focus-visible {
        color: $color-secondary-500;
        background-color: $color-secondary-50;
        border-color: $color-secondary-50;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
        border: 1px solid $color-secondary-200;
      }

      &:active {
        color: $color-secondary-500;
        background-color: $color-secondary-200;
        border-color: $color-secondary-200;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-neutral {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-100;
      border-color: $color-cool-grey-100;

      &:hover {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-200;
        border-color: $color-cool-grey-200;
      }

      &:focus-visible {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
      }

      &:active {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-300;
        border-color: $color-cool-grey-300;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-neutral-outlined {
      color: $color-cool-grey-700;
      background-color: $color-cool-grey-100;
      border: 1px solid $color-cool-grey-200;

      &:hover {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-200;
        border-color: $color-cool-grey-200;
        border: 1px solid $color-cool-grey-200;
      }

      &:focus-visible {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
        border: 1px solid $color-cool-grey-200;
      }

      &:active {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-300;
        border-color: $color-cool-grey-300;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-ghost {
      color: $color-cool-grey-700;
      background-color: transparent;
      border-color: transparent;

      &:hover {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;
      }

      &:focus-visible {
        color: $color-cool-grey-700;
        background-color: transparent;
        border-color: transparent;
        outline: $space-4xs solid $color-primary-200;
        outline-offset: $space-4xs;
      }

      &:active {
        color: $color-cool-grey-700;
        background-color: $color-cool-grey-200;
        border-color: $color-cool-grey-200;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: transparent;
        border-color: transparent;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-filled-on-color {
      color: $color-primary-500;
      background-color: $color-white;
      border-color: $color-white;

      &:hover {
        color: $color-primary-500;
        background-color: $color-cool-grey-50;
        border-color: $color-cool-grey-50;
      }

      &:focus-visible {
        color: $color-primary-500;
        background-color: $color-white;
        border-color: $color-white;
        outline: $space-4xs solid $color-white;
        outline-offset: $space-4xs;
      }

      &:active {
        color: $color-primary-500;
        background-color: $color-cool-grey-100;
        border-color: $color-cool-grey-100;
      }

      &:disabled {
        color: $color-cool-grey-300;
        background: rgba(255, 255, 255, 0.2);
        background: rgba(255, 255, 255, 0.2);

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }

    &.icon-button-outline-on-color {
      color: $color-white;
      background-color: transparent;
      border: 1px solid $color-white;

      &:hover {
        color: $color-primary-500;
        background-color: $color-white;
        border-color: $color-white;

        i, svg {
          color: $color-primary-500;
        }
      }

      &:focus-visible {
        color: $color-white;
        background-color: transparent;
        border-color: transparent;
        outline: $space-4xs solid $color-white;
        outline-offset: $space-4xs;
      }

      &:active {
        color: $color-primary-500;
        background-color: $color-cool-grey-50;
        border-color: $color-cool-grey-50;

        i, svg {
          color: $color-primary-500;
        }
      }

      &:disabled {
        color: $color-cool-grey-300;
        background-color: transparent;
        border-color: transparent;

        i, svg {
          color: $color-cool-grey-300;
        }
      }
    }
}
</style>
